module.exports = __webpack_public_path__ + "static/media/Hamburger.7bb7c66e.svg";